export default "__VITE_ASSET__BXrvFOxy__"